// This file was generated by lezer-generator. You probably shouldn't edit it.
export const
  spaces = 39,
  newline = 40,
  LineComment = 1,
  BlockComment = 2,
  SingleExpression = 3,
  Number = 4,
  String = 5,
  Escape = 6,
  VariableName = 7,
  BackTickString = 8,
  backTickEscape = 9,
  BooleanLiteral = 10,
  UnaryExpression = 11,
  ParenthesizedExpression = 16,
  BinaryExpression = 17,
  divide = 19,
  LessThan = 21,
  questionOp = 27,
  FunctionName = 30,
  ArgList = 31
